// WARNING: Assets are served from the Editor's version of the player
// Either update the Editor or use the theatro360-manual-assets S3 bucket

// const s3 = "https://theatro360-manual-assets.s3-us-west-2.amazonaws.com";
// const origin = window.location.origin + "/tour/assets";


let systemTheme;

const replaceNullProperties = (source, defaults) => {
  for (let prop in source) {
    if (typeof source[prop] === 'object' && source[prop] !== null) {
      source[prop] = replaceNullProperties(source[prop], defaults[prop]);
    } else if ((source[prop] === null || source[prop] === "") && defaults.hasOwnProperty(prop)) {
      source[prop] = defaults[prop];
    }
  }

  return source;
}

export const storeTheme = (theme) => {

  if (theme && typeof theme === 'object' && Object.keys(theme).length) {
    const origin = window.location.origin + "/tour/assets";

    let _defaults = {
      theme: {
        popupPrimary: "#000", // pop up header
        popupSecondary: "rgba(0, 0, 0, 0.7)", // pop up body
        popUpHeaderText: "#ffffff",
        popUpBodyText: "#ffffff",
        timelineBorder: "#37bbc8",
        textDefault: "#ffffff",
        textShadow: "#1d1d1d",
        textHighlight: "#37bbc8",
        dropdownCategory: '#545A60',
        dropdownCategorySelected: "#365161",
        dropdownPrimary: "#2A3742",
        dropdownPrimarySelected: "#365161",
        dropdownSubItem: "rgba(0, 0, 0, 0.5)",
        dropdownSubItemSelected: "rgba(0, 0, 0, 0.6)",
        dropdownText: null, // textDefault
        dropdownTextSelected: null,
        linksPrimary: null,
        linksPrimarySelected: null,
        linksSubItem: null,
        linksSubItemSelected: null,
        titleText: null,
        titleBackground: "#1C242B",
        linksText: null,
        popupSpace: null,
        popupHeaderDirection: null,
        pulse: "#ffbc0d",
        hotspotHover: "#18c1d8"
      },
      loader: {
        src: `${origin}/hover-icon.svg`,
        // color: "rgba(34, 34, 34, 0.7)"
      },
      deckPin: {
        hover: `${origin}/deck-hotspot-hover-default.png`,
        default: `${origin}/deck-hotspot-default.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-default.png`
      },
      baseplate: `${origin}/baseplate-theatro.png`
    };

    theme = replaceNullProperties(theme, _defaults);

    // if (!theme.loader.position) {
    //   if (theme.loader.positionX !== null || theme.loader.positionY !== null) {
    //     let posX = theme.loader.positionX || 0;
    //     let posY = theme.loader.positionY || 0;
    //     theme.loader.position = `calc(50% - ${posX}px) calc(50% + ${posY}px)`
    //   } else {
    //     theme.loader.position = "calc(50% - 1px) calc(50% + 15px)"
    //   }
    // }
  }

  systemTheme = theme;
};

export const getBaseplate = () => {

  const subdomain = window.location.host.split(".")[0];
  const origin = window.location.origin + "/tour/assets";

  if (systemTheme && systemTheme.baseplate) {
    return systemTheme.baseplate;
  }

  switch (subdomain) {
    case "burgess":
      return `${origin}/burgess-baseplate.png`;
    case "skanska":
      return `${origin}/skanska-baseplate.png`;
    case "mayfair":
      return `${origin}/mayfair-baseplate.png`;
    case "radisson":
      return `${origin}/radisson-baseplate.png`;
    case "diageo":
      return `${origin}/blank-baseplate.png`;
    case "ventura":
      return `${origin}/ventura-baseplate.png`;
    case "cdw":
      return `${origin}/cdw-baseplate.png`;
    case "britishairways":
      return `${origin}/britishairways-baseplate.png`;
    case "mys":
      return `${origin}/MYS-grey-baseplate.png`;
    case "propertyjigsaw":
      return `${origin}/pj-baseplate.png`;
    case "kk":
      return `${origin}/kk-baseplate.jpg`;
    case "edmiston":
      return `${origin}/edmiston-baseplate.png`;
    case "northropjohnson":
      return `${origin}/N&J-baseplate.png`;
    case "fraser":
      return `${origin}/fraser-baseplate.png`;
    case "yco":
      return `${origin}/yco-baseplate.png`;
    case "lyc":
      return `${origin}/lyc-baseplate.png`;
    default:
      return `${origin}/baseplate-theatro.png`;
  }
};

export const getLoader = () => {

  const subdomain = window.location.host.split(".")[0];
  const origin = window.location.origin + "/tour/assets";

  if (systemTheme && systemTheme.loader) {
    return systemTheme.loader;
  }

  switch (subdomain) {
    case "burgess":
      return {
        src: `${origin}/burgess_loader.png`,
        color: "rgba(23, 190, 218, 0.7)",
      };
    case "kk":
      return {
        src: `${origin}/kk-thumbnail-hover.jpg`,
        color: "rgba(255, 255, 255)", // image has no transparency
      };
    default:
      return {
        src: `${origin}/hover-icon.svg`,
        color: "rgba(34, 34, 34, 0.7)",
        position: "calc(50% - 1px) calc(50% + 15px)",
      };
  }
};

export const getPins = () => {
  const subdomain = window.location.host.split(".")[0];
  const origin = window.location.origin + "/tour/assets";

  if (systemTheme && systemTheme.deckPin) {
    let pin = systemTheme.deckPin;
    return {
      hover: pin.hover || `${origin}/deck-hotspot-hover-default.png`,
      default: pin.default || `${origin}/deck-hotspot-default.png`,
      active: pin.active || `${origin}/deck-hotspot-active-default.png`,
      arrow: pin.arrow || `${origin}/dropdown-arrow-default.png`,
    }
  }

  switch (subdomain) {
    case "edmiston":
      return {
        hover: `${origin}/deck-hotspot-hover-edmiston.png`,
        default: `${origin}/deck-hotspot-edmiston.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-edmiston.png`,
      };
    case "northropjohnson":
      return {
        hover: `${origin}/deck-hotspot-hover-northropjohnson.png`,
        default: `${origin}/deck-hotspot-northropjohnson.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-northropjohnson.png`,
      };
    case "fraser":
      return {
        hover: `${origin}/deck-hotspot-hover-fraser.png`,
        default: `${origin}/deck-hotspot-fraser.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-fraser.png`,
      };
    case "yachts":
      return {
        hover: `${origin}/deck-hotspot-hover-yachts.png`,
        default: `${origin}/deck-hotspot-yachts.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-yachts.png`,
      };
    case "yco":
      return {
        hover: `${origin}/deck-hotspot-hover-yco.png`,
        default: `${origin}/deck-hotspot-yco.png`,
        active: `${origin}/deck-hotspot-active-yco.png`,
        arrow: `${origin}/dropdown-arrow-yco.png`,
      };
    case "sym":
      return {
        hover: `${origin}/deck-hotspot-hover-sym.png`,
        default: `${origin}/deck-hotspot-sym.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-sym.png`,
      };
    case "lyc":
      return {
        hover: `${origin}/deck-hotspot-hover-lyc.png`,
        default: `${origin}/deck-hotspot-lyc.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-lyc.png`,
      };
    default:
      return {
        hover: `${origin}/deck-hotspot-hover-default.png`,
        default: `${origin}/deck-hotspot-default.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-default.png`,
      };
  }
};

export const getColour = () => {
  const subdomain = window.location.host.split(".")[0];

  if (systemTheme && systemTheme.theme && systemTheme.theme.hotspotHover) {
    return systemTheme.theme.hotspotHover;
  }

  switch (subdomain) {
    case "edmiston":
      return 0xdc0121;
    case "northropjohnson":
      return 0xfe7311;
    case "fraser":
      return 0xed8880;
    case "yachts":
      return 0xcccccc;
    case "yco":
      return 0xffc719;
    case "hillrobinson":
      return 0xffc719;
    case "sym":
      return 0xffffff;
    case "lyc":
      return 0xd7ff80;
    default:
      return 0x18c1d8;
  }
};

export const getTheme = () => {

  if (systemTheme && systemTheme.theme) {
    console.log("LOADED THEME", systemTheme.theme);
    return systemTheme.theme;
  }

  if (window.location.pathname.includes("AM-437D")) {
    return {
      popupPrimary: "black",
      popupSecondary: "rgba(0, 0, 0, 0.7)",
      popUpHeaderText: "#f3c736", // new
      popUpBodyText: "#f3c736", // new
      timelineBorder: "#f3c736", // new
      textDefault: "white",
      textShadow: "#1d1d1d",
      textHighlight: "#f3c736",
      dropdownPrimary: "#22262a",
      dropdownPrimarySelected: "rgb(31, 43, 52)",
      dropdownSubItem: "rgba(0, 0, 0, 0.4)",
      dropdownSubItemSelected: "rgba(0, 0, 0, 0.6)",
      linksPrimary: "rgb(34, 72, 83)",
      linksPrimarySelected: "rgba(34, 72, 83, 0.8)",
      linksSubItem: "rgba(0, 0, 0, 0.4)",
      linksSubItemSelected: "rgba(0, 0, 0, 0.6)",
      linksText: "white",
    };
  }

  const subdomain = window.location.host.split(".")[0];

  switch (subdomain) {
    case "fraser":
      return {
        popupPrimary: "white",
        popupSecondary: "rgba(255, 255, 255, 0.7)",
        popUpHeaderText: "#0A1B40", // new
        popUpBodyText: "#0A1B40", // new
        timelineBorder: "#0A1B40", // new
        textDefault: "#0A1B40",
        textShadow: "none",
        textHighlight: "#ED8880",
        dropdownPrimary: "white",
        dropdownPrimarySelected: "rgba(255, 255, 255, 0.85)",
        dropdownSubItem: "rgba(255, 255, 255, 0.7)",
        dropdownSubItemSelected: "rgba(255, 255, 255, 0.9)",
        linksPrimary: "rgb(34, 72, 83)",
        linksPrimarySelected: "rgba(34, 72, 83, 0.8)",
        linksSubItem: "rgba(0, 0, 0, 0.4)",
        linksSubItemSelected: "rgba(0, 0, 0, 0.6)",
        linksText: "white",
        pulse: "#ffbc0d",
      };
    case "yachts":
      return {
        popupPrimary: "white",
        popupSecondary: "rgba(255, 255, 255, 0.7)",
        popUpHeaderText: "#0A1B40", // new
        popUpBodyText: "#0A1B40", // new
        timelineBorder: "#0A1B40", // new
        textDefault: "#0A1B40",
        textShadow: "none",
        textHighlight: "#37bbc8",
        dropdownPrimary: "white",
        dropdownPrimarySelected: "rgba(255, 255, 255, 0.85)",
        dropdownSubItem: "rgba(255, 255, 255, 0.7)",
        dropdownSubItemSelected: "rgba(255, 255, 255, 0.9)",
        linksPrimary: "rgb(34, 72, 83)",
        linksPrimarySelected: "rgba(34, 72, 83, 0.8)",
        linksSubItem: "rgba(0, 0, 0, 0.4)",
        linksSubItemSelected: "rgba(0, 0, 0, 0.6)",
        linksText: "white",
        pulse: "#ffbc0d",
      };

    // #ffc719
    case "yco":
      return {
        popupPrimary: "black",
        popupSecondary: "black",
        popUpHeaderText: "#ffc719", // new
        popUpBodyText: "#ffc719", // new
        timelineBorder: "#ffc719", // new
        textDefault: "#ffffff",
        textShadow: "none",
        textHighlight: "#ffc619",
        dropdownTextSelected: "#ffc719",
        dropdownPrimary: "rgba(0, 0, 0, 0.6)",
        dropdownPrimarySelected: "rgba(0, 0, 0, 0.6)",
        dropdownSubItem: "rgba(0, 0, 0, 0.6)",
        dropdownSubItemSelected: "rgba(0, 0, 0, 0.8)",
        linksPrimary: "rgba(0, 0, 0, 0.6)",
        linksPrimarySelected: "rgba(0, 0, 0, 0.6)",
        linksSubItem: "rgba(0, 0, 0, 0.6)",
        linksSubItemSelected: "rgba(0, 0, 0, 0.8)",
        linksText: "#ffffff",
        linksTextActive: "#ffc719",
        popupSpace: 0,
        popupHeaderDirection: "row-reverse",
        pulse: "#ffbc0d",
      };

    // #ffc719
    case "hillrobinson":
      return {
        popupPrimary: "black",
        popupSecondary: "black",
        popUpHeaderText: "#bba573", // new
        popUpBodyText: "#bba573", // new
        timelineBorder: "#bba573", // new
        textDefault: "#ffffff",
        textShadow: "none",
        textHighlight: "#bba573",
        dropdownTextSelected: "#bba573",
        dropdownPrimary: "rgba(15,32,78,0.9)",
        dropdownPrimarySelected: "rgba(15,32,78,0.9)",
        dropdownSubItem: "rgba(15,32,78,0.7)",
        dropdownSubItemSelected: "rgba(15,32,78,0.9)",
        linksPrimary: "rgba(15,32,78,0.9)",
        linksPrimarySelected: "rgba(15,32,78,0.9)",
        linksSubItem: "rgba(15,32,78,0.7)",
        linksSubItemSelected: "rgba(15,32,78,0.9)",
        linksText: "#ffffff",
        linksTextActive: "#bba573",
        popupSpace: 0,
        popupHeaderDirection: "row-reverse",
        pulse: "#bba573",
      };
    case "sym":
      return {
        popupPrimary: "black",
        popupSecondary: "black",
        popUpHeaderText: "#f0c266", // new
        popUpBodyText: "#f0c266", // new
        timelineBorder: "#f0c266", // new
        textDefault: "#ffffff",
        textShadow: "none",
        textHighlight: "#ffc619",
        dropdownTextSelected: "#f0c266",
        dropdownPrimary: "rgba(14, 35, 58, 0.9)",
        dropdownPrimarySelected: "rgba(14, 35, 58, 0.9)",
        dropdownSubItem: "rgba(14, 35, 58, 0.7)",
        dropdownSubItemSelected: "rgba(14, 35, 58, 0.9)",
        linksPrimary: "rgba(14, 35, 58, 0.9)",
        linksPrimarySelected: "rgba(14, 35, 58, 0.9)",
        linksSubItem: "rgba(14, 35, 58, 0.7)",
        linksSubItemSelected: "rgba(14, 35, 58, 0.9)",
        linksText: "#ffffff",
        linksTextActive: "#f0c266",
        pulse: "#ffbc0d",
      };
    case "lifearc":
      return {
        popupPrimary: "black",
        popupSecondary: "rgba(0, 0, 0, 0.7)",
        popUpHeaderText: "#37bbc8", // new
        popUpBodyText: "#37bbc8", // new
        timelineBorder: "#37bbc8", // new
        textDefault: "white",
        textShadow: "#1d1d1d",
        textHighlight: "#37bbc8",
        dropdownPrimary: "#22262a",
        dropdownPrimarySelected: "rgb(31, 43, 52)",
        dropdownSubItem: "rgba(0, 0, 0, 0.4)",
        dropdownSubItemSelected: "rgba(0, 0, 0, 0.6)",
        linksPrimary: "rgb(34, 72, 83)",
        linksPrimarySelected: "rgba(34, 72, 83, 0.8)",
        linksSubItem: "rgba(0, 0, 0, 0.4)",
        linksSubItemSelected: "rgba(0, 0, 0, 0.6)",
        linksText: "white",
        pulse: "#5acb5a",
      };
    case "lyc":
      return {
        popupPrimary: "black",
        popupSecondary: "black",
        popUpHeaderText: "#f0c266", // new
        popUpBodyText: "#f0c266", // new
        timelineBorder: "#f0c266", // new
        textDefault: "#ffffff",
        textShadow: "none",
        textHighlight: "#ffc619",
        dropdownTextSelected: "#d7ff80",
        dropdownPrimary: "rgba(0, 46, 70, 0.9)",
        dropdownPrimarySelected: "rgba(0, 46, 70, 0.9)",
        dropdownSubItem: "rgba(0, 46, 70, 0.7)",
        dropdownSubItemSelected: "rgba(0, 46, 70, 0.9)",
        linksPrimary: "rgba(0, 46, 70, 0.9)",
        linksPrimarySelected: "rgba(0, 46, 70, 0.9)",
        linksSubItem: "rgba(0, 46, 70, 0.7)",
        linksSubItemSelected: "rgba(0, 46, 70, 0.9)",
        linksText: "#ffffff",
        linksTextActive: "#d7ff80",
        pulse: "#d7ff80",
      };
    default:
      console.log("DEFAULT THEME");
      return {
        popupPrimary: "#000",  // pop up header
        popupSecondary: "rgba(0, 0, 0, 0.7)", // pop up body
        popUpHeaderText: "#ffffff",
        popUpBodyText: "#ffffff",
        timelineBorder: "#37bbc8",
        textDefault: "#ffffff",
        textShadow: "#1d1d1d",
        textHighlight: "#37bbc8",
        dropdownCategory: '#545A60',
        dropdownCategorySelected: "#365161",
        dropdownPrimary: "#2A3742",
        dropdownPrimarySelected: "#365161",
        dropdownSubItem: "rgba(0, 0, 0, 0.5)",
        dropdownSubItemSelected: "rgba(0, 0, 0, 0.6)",   
        dropdownText: null, // textDefault
        dropdownTextSelected: null,
        titleText: null,
        titleBackground: "#1C242B",
        linksPrimary: null,
        linksPrimarySelected: null,
        linksSubItem: null,
        linksSubItemSelected: null,
        linksText: null,
        pulse: "#ffbc0d",
      };
  }
};
